import { Lightning } from '@lightningjs/sdk'

import { getColor, grey200, grey50, grey600, grey960 } from '../../constants/colors'

const TOGGLE_WIDTH = 100
const TOGGLE_HEIGHT = 60
const CIRCLE_SIZE = 30
const CIRCLE_RADIUS = 15
const SAFE_ZONE = 10
const SCALE = 1.4

export class Toggle extends Lightning.Component {
  private _isOn = false

  static _template() {
    return {
      w: TOGGLE_WIDTH,
      h: TOGGLE_HEIGHT,
      rect: true,
      flex: { alignItems: 'center' },
      shader: {
        type: Lightning.shaders.RoundedRectangle,
        stroke: 4,
        strokeColor: getColor(grey600),
        fillColor: getColor(grey200),
        radius: TOGGLE_HEIGHT / 2,
      },
      Circle: {
        x: SAFE_ZONE,
        w: CIRCLE_SIZE,
        h: CIRCLE_SIZE,
        rect: true,
        color: getColor(grey600),
        shader: {
          type: Lightning.shaders.RoundedRectangle,
          radius: CIRCLE_RADIUS,
        },
      },
    }
  }

  get circle() {
    return this.tag('Circle')
  }

  set isOn(v: boolean) {
    this._isOn = v

    this.toggle(v)
  }

  get isOn() {
    return this._isOn
  }

  toggle(toggle: boolean) {
    this.patch({
      shader: {
        strokeColor: toggle ? getColor(grey960) : getColor(grey600),
        fillColor: toggle ? getColor(grey960) : getColor(grey200),
      },
      Circle: {
        w: CIRCLE_SIZE * (toggle ? SCALE : 1),
        h: CIRCLE_SIZE * (toggle ? SCALE : 1),
        color: toggle ? getColor(grey50) : getColor(grey600),
        shader: {
          radius: CIRCLE_RADIUS * (toggle ? SCALE : 1),
        },
      },
    })

    this.translate(toggle)
  }

  translate(active: boolean) {
    this.circle.patch({
      smooth: {
        x: active ? TOGGLE_WIDTH / 2 : SAFE_ZONE,
      },
    })
  }
}
